const styles = {
  paper: {
    cursor: "pointer",
    border: "1px dashed #888",
    borderRadius: "10px",
    width: "75%",
    minHeight: { xs: "fit-content", sm: 150 },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    p: 4,
  },
};

export default styles;
